/** Full same-origin API base URL. Vite proxies this path during development. */
export const API_BASE_URL = '/api/v1'

/** Server host used for same-origin static assets (for example product images). */
export const API_HOST = ''

/** Same-origin SSE endpoint URL. */
export const SSE_URL = '/api/v1/notifications/stream'
